























































































































































import { Component, Vue, Prop, Watch, Provide } from "vue-property-decorator";
import analyticsLayerUtil from "./../utils/index";

enum Region {
  US = "US",
  CA = "CA",
}

@Component({})
export default class Taxability extends Vue {
  allRegionsData: {}[] = [
    {
      label: "United States of America (USA)",
      value: Region.US,
    },
    { label: "Canada", value: Region.CA },
  ];
  selectedRegion = Region.US;

  public onRegionSelected(e: any) {
    this.selectedRegion = e.detail.item.value;
  }

  public onTaxabilityBuild(e: any) {
    analyticsLayerUtil.commitDataLayer();
    this.$router.push({
      path: `/taxability/search`,
    });
  }

  public captureFullTaxabilityDownload() {
    const props = {
      taxibilityMatrix: {
        taxibilityMatrixInfo: {
          selectedCountry: this.selectedRegion,
        },
      },
    };
    analyticsLayerUtil.addToDataLayer(props);
    if (this.$store.getters.analyticsEnabled) {
      window._satellite.track("taxability_full_download");
    }
  }
}
